import { v4 as uuidv4 } from 'uuid';

export function SellerHead(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerHead',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
